import { Subject } from '@state-containers/core';
import {
  DEFAULT_DURATION,
  MINUTE_HEIGHT,
  SNAP_INTERVAL,
} from '../../../constants/calendar';

interface CreateBlockState {
  isDragging: boolean;
  blockStartMinutes: number | null;
  blockEndMinutes: number | null;
  currentDay: Date | null;
}

const snapToNearestInterval = (pixels: number): number => {
  const minutes = pixels / MINUTE_HEIGHT;
  const snappedMinutes = Math.round(minutes / SNAP_INTERVAL) * SNAP_INTERVAL;
  return snappedMinutes;
};

export const BlockCreatorState = () => {
  const state = new Subject<CreateBlockState>({
    isDragging: false,
    blockStartMinutes: null,
    blockEndMinutes: null,
    currentDay: null,
  });

  const actions = {
    onCursorMove: (y: number, day: Date) => {
      y = y - 4;
      if (state.value.isDragging) {
        state.value = {
          ...state.value,
          blockEndMinutes: snapToNearestInterval(y),
        };
      } else {
        const snappedMinutes = snapToNearestInterval(y);
        state.value = {
          ...state.value,
          blockStartMinutes: snappedMinutes,
          blockEndMinutes: snappedMinutes + DEFAULT_DURATION,
          currentDay: day,
        };
      }
    },
    onMouseDown: () => {
      state.value = {
        ...state.value,
        isDragging: true,
      };
    },
    onMouseUp: () => {
      if (
        !state.value.isDragging ||
        !state.value.blockStartMinutes ||
        !state.value.blockEndMinutes ||
        !state.value.currentDay
      )
        return null;

      const start = state.value.blockStartMinutes;
      const end = state.value.blockEndMinutes;
      const day = state.value.currentDay;

      state.value = {
        isDragging: false,
        blockStartMinutes: null,
        blockEndMinutes: null,
        currentDay: null,
      };

      return {
        startTime: new Date(
          day.getFullYear(),
          day.getMonth(),
          day.getDate(),
          Math.floor(start / 60),
          start % 60,
        ),
        endTime: new Date(
          day.getFullYear(),
          day.getMonth(),
          day.getDate(),
          Math.floor(end / 60),
          end % 60,
        ),
      };
    },
    onMouseLeave: () => {
      state.value = {
        isDragging: false,
        blockStartMinutes: null,
        blockEndMinutes: null,
        currentDay: null,
      };
    },
  };

  return { state, actions };
};
